import React from 'react'
import ScopeTemplate from '../../components/ScopeTemplate/ScopeTemplate'

function Space() {
    const overview =
        'We develop high-reliability electronic subsystems engineered for high-altitude and space-oriented applications requiring operational stability under extreme environmental conditions. Our in-house R&D team focuses on optimized, compact, and robust architectures supported by advanced simulation and validation processes.'

    const points = [
        'High-density, high-reliability PCB design & fabrication',
        'Embedded processing and control electronics',
        'Power conditioning & regulated distribution modules',
        'Thermal & vibration validation through NABL Accredited Lab',
        'Prototype realization to batch production under controlled QMS',
    ]

    const tags = [
        'PCB Design',
        'Embedded Processing',
        'Power Conditioning',
        'Validation',
    ]

    return (
        <ScopeTemplate
            title='SPACE'
            subtitle='High-Reliability Electronic Subsystems'
            overview={overview}
            points={points}
            tags={tags}
        />
    )
}

export default Space